import { inject } from "@angular/core";
import { type CanActivateFn, Router } from "@angular/router";

import { AuthService } from "../services/auth.service";

/**
 * Route guard function that checks if the user is authorized.
 * Redirects to `/403` if not authorized.
 *
 * @function
 * @returns {boolean} True if the user is authorized, otherwise false.
 */
export const AuthGuard: CanActivateFn = (): boolean => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthorized()) {
    return true;
  }
  router.navigate(["/403"]);
  return false;
};
